import React, { Fragment, useContext } from "react";
import SelectableTable from "components/DesignSystem/SelectableTable";
import { Link, useHistory, useLocation } from "react-router-dom";
import { packClasses } from "Utils";
import { AuthorListContext } from ".";
import { range } from "lodash";

export default function AuthorListTable(props) {
    const { items, selectedItems, loading } = useContext(AuthorListContext);
    const history = useHistory();
    const location = useLocation();

    const selectAll = (e) => {
        if (e.target.checked) {
            props.setAllSelected(items.map((item) => item.uuid));
        } else {
            props.setAllSelected([]);
        }
    };

    const updateParams = (key, val = null) => {
        const params = new URLSearchParams(location.search);

        if (typeof key === "object") {
            Object.entries(key).forEach(([k, v]) => {
                params.set(k, v);
            });
        } else {
            if (params.has(key) && params.get(key) === val) {
                params.delete(key);
            } else {
                params.set(key, val);
            }
        }

        history.replace(location.pathname + "?" + params.toString());
    };

    const onSort = (sortKey) => {
        let sortDir = "desc";
        if (
            props.queryParams.has("order") &&
            props.queryParams.get("order") === sortKey
        ) {
            if (
                props.queryParams.has("dir") &&
                props.queryParams.get("dir") === "asc"
            ) {
                sortDir = "desc";
            } else {
                sortDir = "asc";
            }
        }

        updateParams({ order: sortKey, dir: sortDir });
    };

    return (
        <SelectableTable total={items.length} selected={selectedItems.length}>
            {({ innerRef }) => (
                <Fragment>
                    <thead className="bg-gray-50 ">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                                <input
                                    type="checkbox"
                                    className="appearance-none rounded text-green-700 focus:ring-green-700"
                                    ref={innerRef}
                                    onChange={(e) => selectAll(e)}
                                />
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                                <button
                                    type="button"
                                    className={packClasses(
                                        "text-xs uppercase tracking-wider",
                                        !props.queryParams.has("order") ||
                                            props.queryParams.get("order") ===
                                                "name"
                                            ? "font-bold text-gray-800"
                                            : "font-medium"
                                    )}
                                    onClick={() => onSort("name")}
                                >
                                    Name
                                </button>
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                                <button
                                    type="button"
                                    className={packClasses(
                                        "text-xs uppercase tracking-wider",
                                        props.queryParams.has("order") &&
                                            props.queryParams.get("order") ===
                                                "slug"
                                            ? "font-bold text-gray-800"
                                            : "font-medium"
                                    )}
                                    onClick={() => onSort("slug")}
                                >
                                    Slug
                                </button>
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                                <button
                                    type="button"
                                    className={packClasses(
                                        "text-xs uppercase tracking-wider",
                                        props.queryParams.has("order") &&
                                            props.queryParams.get("order") ===
                                                "status"
                                            ? "font-bold text-gray-800"
                                            : "font-medium"
                                    )}
                                    onClick={() => onSort("status")}
                                >
                                    Status
                                </button>
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                        {loading
                            ? range(0, 10).map((i) => (
                                  <tr className="animate-pulse" key={i}>
                                      <td
                                          className="whitespace-nowrap px-4 py-2"
                                          colSpan={4}
                                      >
                                          <div className="my-1 h-5 rounded bg-gray-300 leading-none">
                                              &nbsp;
                                          </div>
                                      </td>
                                  </tr>
                              ))
                            : items.map((item) => (
                                  <tr key={item.id}>
                                      <td className="whitespace-nowrap px-6 py-2">
                                          <input
                                              className="appearance-none rounded text-green-700 focus:ring-green-700"
                                              type="checkbox"
                                              onChange={(e) => {
                                                  props.addSelected(
                                                      e,
                                                      item.uuid
                                                  );
                                              }}
                                              checked={selectedItems.find(
                                                  (id) => id === item.uuid
                                              )}
                                          />
                                      </td>
                                      <td className="whitespace-nowrap px-6 py-2">
                                          <Link
                                              to={`/app/author/${item.uuid}`}
                                              className="color-gray-800 hover:underline"
                                          >
                                              {item.name}
                                          </Link>
                                      </td>
                                      <td className="whitespace-nowrap px-6 py-2">
                                          <Link
                                              to={`/app/author/${item.uuid}`}
                                              className="color-gray-600 text-sm hover:underline"
                                          >
                                              {item.slug}
                                          </Link>
                                      </td>
                                      <td className="whitespace-nowrap px-6 py-2 text-center">
                                          {item.status === 1 ? (
                                              <div className="inline-block h-4 w-4 rounded-full bg-green-600 text-green-600">
                                                  <span className="sr-only">
                                                      Active
                                                  </span>
                                              </div>
                                          ) : (
                                              <div className="inline-block h-4 w-4 rounded-full bg-red-600 text-red-600">
                                                  <span className="sr-only">
                                                      Inactive
                                                  </span>
                                              </div>
                                          )}
                                      </td>
                                  </tr>
                              ))}
                    </tbody>
                </Fragment>
            )}
        </SelectableTable>
    );
}
